export default "__VITE_ASSET__BNqLZcLO__"